export var UserRegistrationVoStatus;
(function (UserRegistrationVoStatus) {
    UserRegistrationVoStatus["CREATED"] = "CREATED";
    UserRegistrationVoStatus["INVITATION_SENT"] = "INVITATION_SENT";
    UserRegistrationVoStatus["REGISTERED"] = "REGISTERED";
    UserRegistrationVoStatus["API_USER"] = "API_USER";
})(UserRegistrationVoStatus || (UserRegistrationVoStatus = {}));
//# sourceMappingURL=user-registration-vo-status.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/user/user-registration-vo-status.js
// module id = 401
// module chunks = 14